module.exports = __webpack_public_path__ + "static/media/cws5_banner_dashboard2.1977c841.jpg";